import axios from "axios";

import type { TeamBrain } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export const getTeamsBrainsByBrainId = queryOptions({
	queryKey: "teamsBrains",
	async queryFn({ queryKey }) {
		const [_, params] = queryKey;
		const response = await axios.get<TeamBrain[]>(
			`${env.apiUrl}/teams-brains/${params.brainId}`,
		);

		return response.data;
	},
});

export const createTeamsBrain = async (teamsBrain: Partial<TeamBrain>) => {
	const response = await axios.post<TeamBrain>(`${env.apiUrl}/teams-brains`, teamsBrain);

	return response.data;
};

export const deleteTeamsBrainById = async (teamsBrainId: string) => {
	await axios.delete(`${env.apiUrl}/teams-brains/${teamsBrainId}`);

	return teamsBrainId;
};
